/**
 * @generated SignedSource<<c77d4d571cd392bfa21789070e393baf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PLUCategorySelectorShowHiddenButtonQuery$variables = Record<PropertyKey, never>;
export type PLUCategorySelectorShowHiddenButtonQuery$data = {
  readonly pluCategories: ReadonlyArray<{
    readonly id: string;
  }>;
};
export type PLUCategorySelectorShowHiddenButtonQuery = {
  response: PLUCategorySelectorShowHiddenButtonQuery$data;
  variables: PLUCategorySelectorShowHiddenButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PLUCategory",
    "kind": "LinkedField",
    "name": "pluCategories",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PLUCategorySelectorShowHiddenButtonQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PLUCategorySelectorShowHiddenButtonQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "2ca2cbd19ba938742a10c33068c8bddf",
    "id": null,
    "metadata": {},
    "name": "PLUCategorySelectorShowHiddenButtonQuery",
    "operationKind": "query",
    "text": "query PLUCategorySelectorShowHiddenButtonQuery {\n  pluCategories {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d2aa119c6d04612144da46607e0b52d6";

export default node;
